<template>
  <div class="page pa-5">
    <app-loader v-if="checkingSession" />
    <form
      v-else
      class="auth-form"
      @submit.prevent="submit"
    >
      <h2 class="mx-auto mb-10">
        Авторизация
      </h2>
      <v-text-field
        v-model="userName"
        label="Логин"
        outlined
        :error-messages="error"
      />
      <v-text-field
        v-model="password"
        label="Пароль"
        outlined
        type="password"
      />
      <v-btn
        color="primary"
        type="submit"
        class="mx-auto"
        elevation="0"
        large
        block
      >
        Войти
      </v-btn>
    </form>
  </div>
</template>

<script>

export default {
  name: 'Auth',
  data: () => ({
    checkingSession: true,
    userName: process.env.VUE_APP_LOGIN || '',
    password: process.env.VUE_APP_PASS || '',
    error: '',
  }),
  async created() {
    this.checkSession();
  },
  methods: {
    async submit() {
      try {
        this.error = '';
        const { data } = await this.$http.post('Login', {
          userName: this.userName,
          pass64rd: window.btoa(this.password),
        });

        if (data.wms_sid) {
          this.$router.push('/navigation');
        }
      } catch (e) {
        const message = e?.response?.data?.errorMess;
        const authError = 'Не удалось установить связь с сервером 1С';
        this.error = message.includes(authError) ? authError : 'Ошибка сервера';
      }
    },
    async checkSession() {
      const { data } = await this.$http.get('Start').finally(() => {
        setTimeout(() => {
          this.checkingSession = false;
        }, 200);
      });

      if (data.sessionActive) {
        this.$router.push('/navigation');
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.auth-form {
  display: flex;
  flex-direction: column;
  margin-top: 80px;
}
</style>
